export default __webpack_public_path__ + "static/media/045-turn-left.1e8c009e.png";